import React from 'react';
import Loader from './Loader';

const InfiniteLoader = React.forwardRef(({ text = 'Loading more' }, ref) => <Loader ref={ref} text={text} />);

export default InfiniteLoader;
